import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ListTable from '../../../../common/tables/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import { getColumns, getData, getIsLoading } from '../redux/selectors/RfidFilesErrorsSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { TransactionsStyle } from '../../../impc-stock-levels/transactions/component/Transactions.styles';

class RfidFilesErrorsContainer extends Component {
  componentDidMount() {
    this.props.tableLoadData({ tableId: 'RFID_FILES_ERRORS_LIST' }, this.props.appContext.appContext, { id: this.props.row.original.id });
  }

  render() {
    return (
      <TransactionsStyle>
        <ListTable
          listId={TableDefinitions.RFID_FILES_ERRORS_LIST.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
        />
      </TransactionsStyle>
    );
  }
}

RfidFilesErrorsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  tableLoadData: PropTypes.func,
  row: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    isLoading: getIsLoading(state),
    appContext: getAssetType(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidFilesErrorsContainer);
